module.exports = __webpack_public_path__ + "img/Rendimiento-N.93787d99.png";